import numbro from "numbro";
import nzh from "nzh/cn";

export const formatMoney = (value: number, mantissa: number = 2) => {
  value = value || 0;
  let num:any =0;
  try {
    num = numbro(value).format({
      thousandSeparated: true, // 千分位
      mantissa: mantissa, // 小数位
    });
  } catch (error) {
    num=value;
  }
  
  return num;
};
// 不保留0站位小数 例：2.10》2.1
export const formatMoneyZero = (value: number) => {
  value = value || 0;
  return numbro(value).format({
    thousandSeparated: true, // 千分位
  });
};
export const formatInt = (value: number) => {
  value = value || 0;
  return numbro(value).format({
    mantissa: 0, // 小数位
  });
};
export const moneyToChinese = (value: number) => {
  return nzh.toMoney(value, { outSymbol: false });
};
